<!-- src/components/ui/sidebar/SidebarView.vue -->
<template>
  <aside class="w-64 bg-white shadow-lg h-screen">
    <div class="mt-6 mx-5">
      <h1
        class="h-auto flex justify-center items-center rounded-lg text-lg text-stone-800 text-center bg-slate-100 pt-4 pb-5"
      >
        <img src="/img/infraplace-logo.png" alt="roadgis logo" class="w-28" />
      </h1>
    </div>
    <nav class="mt-6 mx-5">
      <router-link
        v-for="item in menuItems"
        :key="item.path"
        :to="item.path"
        class="flex items-center py-3 px-3 text-gray-600 rounded-lg hover:bg-gray-100"
        exact-active-class="bg-primary/5 text-green-800"
        exact
      >
        <DefaultIcon :name="item.icon" class="mr-2" />
        {{ item.name }}
      </router-link>
    </nav>
    <div class="absolute bottom-0 p-4 w-64">
      <div v-if="authStore.user" class="flex items-center">
        <div class="avatar placeholder mr-2">
          <div class="bg-neutral text-neutral-content w-8 rounded-full">
            <span class="text-xs">{{ authStore.user.initials }}</span>
          </div>
        </div>
        <div>
          <p class="font-semibold">
            {{ authStore.user.name }} {{ authStore.user.surname }}
          </p>
          <p class="text-sm text-gray-500">
            {{ roleTranslations[authStore.user.role] }}
          </p>
        </div>
      </div>
      <div v-else><span class="loading loading-spinner loading-md"></span></div>
      <button
        @click="handleLogout"
        class="mt-4 w-full py-2 px-4 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded transition-colors"
      >
        Atsijungti
      </button>
    </div>
  </aside>
</template>

<script setup>
import { defineProps } from "vue";
import DefaultIcon from "@/components/icons/DefaultIcon.vue";

import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";

const router = useRouter();
const authStore = useAuthStore();

const props = defineProps({
  menuItems: {
    type: Array,
    required: true,
  },
});

console.log(props);

const handleLogout = async () => {
  try {
    await authStore.logout();
    router.push("/login");
  } catch (error) {
    console.error("Logout failed:", error);
    // You might want to add error handling here
  }
};

const roleTranslations = {
  org_admin: "Administratorius",
  engineer: "Inžinierius",
  admin: "Administratorius",
};
</script>
